module.exports = __webpack_public_path__ + "img/5.2b13e143.png";